import React from "react";
import {Box, Button, Grid, Input, Typography} from "@mui/material"
import {OptionalVarsDto} from "../../../../../../../dtos";
import {makeStyles} from "@mui/styles";
import {ReactComponent as AddRowIcon} from "../../../../../../../assets/editors/plus_icon.svg";
import {ReactComponent as DeleteRowIcon} from "../../../../../../../assets/editors/delete_icon_line.svg";

const useStyles = makeStyles(() => ({
    optionalVarBox: {
        paddingBottom: `10px`
    },
    conversionUrlSettingInput: {
        width: `100%`,
        lineHeight: `1`,
        // backgroundColor: '#ffffff',
        border: `1px solid #888888`,
        borderRadius: '5px',
        '&.MuiInputBase-multiline': {
            padding: `0`
        },
        '&.MuiInput-root': {
            fontSize: '14px',
        },
        '&.notValid': {
            borderColor: `red`,
        },
        '&.Mui-disabled': {
            backgroundColor: `#dbdbdb`
        }
    },

    variableRowButtonsWrap: {
        display: `flex`,
        justifyContent: `space-around`
    }

}))

interface Props {
    variable: OptionalVarsDto;
    index: number;
    checkValidValue: (value: string) => boolean;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    allVarsData: OptionalVarsDto[];
    addRemoveRowFromOptionalVars: (isAddRow: boolean, rowNumber: number) => void;
}


export const OptionalVar: React.FC<Props> = ({
                                                 variable,
                                                 index,
                                                 checkValidValue,
                                                 handleChange,
                                                 allVarsData,
                                                 addRemoveRowFromOptionalVars
                                             }) => {
    const classes = useStyles();

    const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(event, index);
    }

    const addVariableRow = () => {
        addRemoveRowFromOptionalVars(true, index);
    }
    const deleteVariableRow = () => {
        addRemoveRowFromOptionalVars(false, index);
    }

    return (
        <Box className={classes.optionalVarBox}>
            <Grid container alignItems={`center`}>
                <Grid item xs={4}>
                    <Typography variant={`body2`}>
                        Optional Variable Name{index}
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Input
                        disableUnderline
                        className={`
                                        ${classes.conversionUrlSettingInput}
                                        ${checkValidValue(`optionalVarName${index}`) ? `` : `notValid`}
                                        `}
                        name={`optionalVarName${index}`}
                        value={variable.name}
                        onChange={onChangeInput}
                        inputProps={{maxLength: 100}}
                        sx={{backgroundColor: `#dbeaff`}}
                        placeholder={`externalName`}
                        autoComplete={`off`}
                        // variant="outlined"
                        // label="Outlined"
                        // size="small"
                    />
                </Grid>
                <Grid item xs={1}>
                    <Typography variant={`body2`} textAlign={`end`}>
                        Value{index}:
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Input
                        disableUnderline
                        className={`
                                        ${classes.conversionUrlSettingInput}
                                        ${checkValidValue(`optionalVarValue${index}`) ? `` : `notValid`}
                                        `}
                        name={`optionalVarValue${index}`}
                        value={variable.value}
                        onChange={onChangeInput}
                        inputProps={{maxLength: 100}}
                        sx={{backgroundColor: `#dbeaff`}}
                        placeholder={`Shopping-Flyer`}
                        autoComplete={`off`}
                        disabled={variable.name === ''}
                        // variant="outlined"
                        // label="Outlined"
                        // size="small"
                    />
                </Grid>
                <Grid item xs={1}>
                    <Box className={classes.variableRowButtonsWrap}>
                        {
                            index < 5 && allVarsData.length === index && <Button onClick={addVariableRow} sx={{width: `20px`}}>
                                <AddRowIcon/>
                            </Button>

                        }
                        {
                            index !== 1 && <Button onClick={deleteVariableRow}>
                                <DeleteRowIcon/>
                            </Button>
                        }

                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}